// import * as Sentry from '@sentry/react';
import { AUTHORIZATION_TOKEN } from 'utils/constants/localStorage';

const statusCodes = {
  FORBIDDEN: 403,
  NO_CONTENT: 204,
  UNAUTHORIZED: 401,
};

// todo: kijken voor token
const authorizedRequest = (endpoint, options = {}) => {
  const token = window.localStorage[AUTHORIZATION_TOKEN];
  const authorizationHeader = token ? { Authorization: `Bearer ${token}` } : {};
  const hasContentTypeHeader = options.headers?.['Content-Type'] !== null;
  const hasAcceptHeader = options.headers?.accept !== null;

  const {
    'Content-Type': contentType,
    accept,
    ...otherHeaders
  } = options.headers || {};

  const contentTypeHeader = hasContentTypeHeader
    ? {
        'Content-Type': contentType || 'application/json;charset=UTF-8',
      }
    : {};

  const acceptHeader = hasAcceptHeader
    ? {
        accept: accept || 'application/json, text/plain, */*',
      }
    : {};

  return fetch(endpoint, {
    ...options,
    headers: {
      ...otherHeaders,
      ...contentTypeHeader,
      ...acceptHeader,
      ...authorizationHeader,
    },
  }).then((res) => {
    if (res.status === statusCodes.UNAUTHORIZED) {
      window.location.assign(`${process.env.REACT_APP_EDU_URL}`);
    }

    if (
      res.status === statusCodes.FORBIDDEN &&
      endpoint.endsWith('api/users/me')
    ) {
      window.location.assign(`${process.env.REACT_APP_EDU_URL}`);
    }

    if (!res.ok) {
      throw new Error(res);
    }

    const responseToken = res.headers.get('authorization');
    const contentType = res.headers.get('content-type');

    if (responseToken) {
      localStorage.setItem(AUTHORIZATION_TOKEN, responseToken);
    }

    if (
      res.status === statusCodes.NO_CONTENT ||
      res.headers.get('content-length') === '0'
    ) {
      return null;
    }

    if (contentType.startsWith('text/plain')) {
      return res;
    }

    return res.json();
  });
};

export const get = (endpoint, options) =>
  authorizedRequest(endpoint, {
    method: 'GET',
    ...options,
  });

export const post = (endpoint, body) =>
  authorizedRequest(endpoint, {
    body: body instanceof FormData ? body : JSON.stringify(body),
    headers: body instanceof FormData ? { 'Content-Type': null } : {},
    method: 'POST',
  });

export const put = (endpoint, body) =>
  authorizedRequest(endpoint, {
    body: body instanceof FormData ? body : JSON.stringify(body),
    headers: body instanceof FormData ? { 'Content-Type': null } : {},
    method: 'PUT',
  });

export const remove = (endpoint) =>
  authorizedRequest(endpoint, {
    method: 'DELETE',
  });
